﻿import React, { useContext, useEffect, Fragment } from 'react';
//import { setBookingflowStep } from '../../../../../Resources/Scripts/_Shared/history';

import { BookingFlowContext } from '../BookingFlowContext'

import { Heading } from '../partials/Heading'
import { BackNavigation } from '../partials/BackNavigation'
import { shouldAccountBeUpdated } from '../../../../../Resources/Scripts/_Shared/helpers';
import { Divider } from '../../../../../Resources/Scripts/_Shared/elements/Divider'

const Login = () => {
  const { bookingFlowContext, setBookingFlowContext } = useContext(BookingFlowContext);
  const selectedProductType = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.Type;
  const lang = bookingFlowContext.localization.login;
  let urlParams = new URLSearchParams(window.location.search);
  urlParams = urlParams.toString().length > 0 ? '?' + urlParams.toString() + '&' : '?';

  const loginHandler = () => {
    if (process.env.NODE_ENV !== 'production') {
      if (bookingFlowContext.useMockedLogin) {
        console.log('[Mocked] Login');

        setBookingFlowContext({
          ...bookingFlowContext,
          activeStep: bookingFlowContext.availableSteps.addVehicle.index,
          user: { emailAddress: 'demo@demosson.se', given_name: 'Demo', family_name: 'Demosson' },
          episerver: {
            ...bookingFlowContext.episerver,
            emailAddress: 'demo@demosson.se',
            given_name: 'Demo',
            family_name: 'Demosson',
            b2c: true,
            sf: true
          }
        })

        return;
      }
    }
    window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + 'l=lgn') + '&lang=' + bookingFlowContext.localization.language;
  };
 
  const createAccountHandler = () => {
    if (process.env.NODE_ENV !== 'production') {
      if (bookingFlowContext.useMockedLogin) {
        console.log('[Mocked] Create account');

        setBookingFlowContext({
          ...bookingFlowContext,
          activeStep: bookingFlowContext.availableSteps.createAccount.index,
          guest: false,
          user: { emailAddress: 'demo@demosson.se', given_name: 'Demo', family_name: 'Demosson' },
          episerver: {
            ...bookingFlowContext.episerver,
            emailAddress: 'demo@demosson.se',
            given_name: 'Demo',
            family_name: 'Demosson',
            b2c: true
        }
        })

        return;
      }
    }

    window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + 'l=usr') + '&signUp=true&lang=' + bookingFlowContext.localization.language;
  };

  const createGuestAccountHandler = () => {
    if (process.env.NODE_ENV !== 'production') {
      if (bookingFlowContext.useMockedLogin) {
        console.log('[Mocked] Guest');

        setBookingFlowContext({
          ...bookingFlowContext,
          activeStep: bookingFlowContext.availableSteps.createAccount.index,
          guest: true,
          user: { email: 'demo@demosson.se', givenName: 'Demo', familyName: 'Demosson' },
          episerver: { ...bookingFlowContext.episerver, b2c: true }
        })

        return;
      }
    }

    window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + 'l = gst') + ' & signUp=true & lang=' + bookingFlowContext.localization.language;
  };

  useEffect(() => {
    const loggedIn = bookingFlowContext.episerver.loggedIn;
    const switchAccountUrl = bookingFlowContext.episerver.switchAccountUrl;
    const activeProfile = !!bookingFlowContext.episerver.activeProfile;
    const hasMoreThanOneProfile = bookingFlowContext.episerver.hasMoreThanOneProfile;
    const urlParams = new URLSearchParams(window.location.search);
    const loginType = urlParams.get('L') ?? urlParams.get('l');
    history.replaceState({ activeStep: 0 }, document.title);

    if ((!loggedIn || !loginType) && !hasMoreThanOneProfile) {
      return;
    }

    if (loggedIn && (hasMoreThanOneProfile && !activeProfile)) {
      window.location.href = switchAccountUrl;
      return;
    }

    if (bookingFlowContext.episerver.hasWebticketAccount && !shouldAccountBeUpdated(bookingFlowContext) && (!hasMoreThanOneProfile || activeProfile)) {
      setBookingFlowContext({
        ...bookingFlowContext,
        activeStep: bookingFlowContext.availableSteps.addVehicle.index,
        user: {
          email: bookingFlowContext.episerver.emailAddress,
          givenName: bookingFlowContext.episerver.given_name,
          familyName: bookingFlowContext.episerver.family_name,
        }
      })
    }
    else if (loginType === 'gst') {
        setBookingFlowContext({ ...bookingFlowContext, activeStep: bookingFlowContext.availableSteps.createAccount.index, guest: true })
    }
    else {
      setBookingFlowContext({ ...bookingFlowContext, activeStep: bookingFlowContext.availableSteps.onlineBooking.index, guest: false })
    }


  }, [bookingFlowContext.episerver.activeProfile])

  //useEffect(() => setBookingflowStep(bookingFlowContext.availableSteps.login.index), [])
  const activeProfile = bookingFlowContext.episerver.activeProfile || false;

  if (bookingFlowContext.episerver.loggedIn && (bookingFlowContext.episerver.hasMoreThanOneProfile && !activeProfile)) {
    return (
      <div className="bookingflowpage__loader">
        <div className="aimo-spinner"><span></span><span></span><span></span><span></span></div>
      </div>
    )
  }

  return (
    <div className="bookingflowpage__app bookingflowpage__app--login">
      <BackNavigation />
      <Heading />
      <div className="single-step single-step--login">
        <h2>{lang.heading}</h2>
        {lang.loginPreamble && <p className="margin center">{lang.loginPreamble}</p>}
        <div className={bookingFlowContext.episerver.productType === 2 ? 'single-step__login-wrapper single-step__login-wrapper--margin' : 'single-step__login-wrapper'}>
          <button className="single-step__button single-step__button--proceed" onClick={loginHandler}>{lang.buttons.proceed}</button>
          <Divider text={lang.divider} />
          <button className="single-step__button single-step__button--createaccount" onClick={createAccountHandler}>{lang.buttons.createAccount}</button>
        </div>
        {bookingFlowContext.episerver.productType === 2 && <Fragment>
          <Divider />
          <h3 className="nomargin">{lang.guest.heading}</h3>
          <p className="margin center">{lang.guest.text}</p>
          <button className="single-step__button single-step__button--blue single-step__button--createguestaccount" onClick={createGuestAccountHandler}>{lang.buttons.guestAccount}</button>
        </Fragment>}
      </div>
    </div>
  )
}

export default Login;
